// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 749 ? "group-restorant" : chunkId) + "." + {"749":"f8daf69a","822":"d5a98ccc"}[chunkId] + ".css";
};